// Updated Sepolia Contract ABI - No TDU Token Dependencies
const contractABI = [
     {
       "inputs": [],
       "stateMutability": "nonpayable",
       "type": "constructor"
     },
     {
    "anonymous": false,
       "inputs": [
         {
        "indexed": true,
        "internalType": "uint256",
        "name": "dataUnitId",
        "type": "uint256"
      },
      {
        "indexed": true,
           "internalType": "address",
        "name": "provider",
           "type": "address"
         },
         {
        "indexed": false,
           "internalType": "uint256",
        "name": "price",
           "type": "uint256"
         }
       ],
    "name": "DataUnitCreated",
    "type": "event"
     },
     {
    "anonymous": false,
       "inputs": [
         {
        "indexed": true,
        "internalType": "uint256",
        "name": "dataUnitId",
        "type": "uint256"
      },
      {
        "indexed": true,
           "internalType": "address",
        "name": "buyer",
           "type": "address"
         },
         {
        "indexed": false,
           "internalType": "uint256",
        "name": "price",
           "type": "uint256"
      }
    ],
    "name": "DataUnitPurchased",
    "type": "event"
         },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_dataUnitId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "_quantity",
        "type": "uint256"
      }
    ],
    "name": "buyDataUnit",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
     {
       "inputs": [
         {
        "internalType": "string",
        "name": "_data",
        "type": "string"
      },
      {
        "internalType": "uint256",
        "name": "_price",
        "type": "uint256"
      },
      {
        "internalType": "string",
        "name": "_dataUnitType",
        "type": "string"
      }
    ],
    "name": "createDataUnit",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "dataUnitCreationCost",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAllDataUnitTypes",
    "outputs": [
      {
        "internalType": "string[]",
        "name": "",
        "type": "string[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAllDataUnits",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "data",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "dataUnitType",
            "type": "string"
          },
          {
            "internalType": "address payable",
            "name": "provider",
           "type": "address"
         },
         {
           "internalType": "uint256",
            "name": "totalRevenue",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "purchaseCount",
           "type": "uint256"
         }
       ],
        "internalType": "struct FXDataNetworkSepolia.DataUnit[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getAllProviders",
    "outputs": [
      {
        "components": [
          {
            "internalType": "address payable",
            "name": "walletAddress",
           "type": "address"
         },
         {
            "internalType": "uint256",
            "name": "balance",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "bool",
            "name": "active",
            "type": "bool"
          },
          {
           "internalType": "uint256",
            "name": "sales",
           "type": "uint256"
         }
       ],
        "internalType": "struct FXDataNetworkSepolia.Provider[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
     },
     {
       "inputs": [
         {
        "internalType": "uint256",
        "name": "_dataUnitId",
        "type": "uint256"
      }
    ],
    "name": "getAvailableDataUnitsById",
       "outputs": [
      {
        "components": [
         {
           "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "data",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "dataUnitType",
            "type": "string"
          },
          {
            "internalType": "address payable",
            "name": "provider",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "totalRevenue",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "purchaseCount",
           "type": "uint256"
          }
        ],
        "internalType": "struct FXDataNetworkSepolia.DataUnit",
        "name": "",
        "type": "tuple"
         }
       ],
       "stateMutability": "view",
       "type": "function"
     },
     {
    "inputs": [],
    "name": "getBuyerDataUnits",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "data",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "dataUnitType",
            "type": "string"
          },
          {
            "internalType": "address payable",
            "name": "provider",
           "type": "address"
         },
         {
           "internalType": "uint256",
            "name": "totalRevenue",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "purchaseCount",
           "type": "uint256"
         }
       ],
        "internalType": "struct FXDataNetworkSepolia.DataUnit[]",
           "name": "",
        "type": "tuple[]"
         }
       ],
    "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [
         {
        "internalType": "uint256",
        "name": "_dataUnitId",
        "type": "uint256"
      }
    ],
    "name": "getDataUnitPurchaseCount",
       "outputs": [
         {
           "internalType": "uint256",
           "name": "",
           "type": "uint256"
         }
       ],
       "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [
         {
        "internalType": "uint256",
        "name": "_dataUnitId",
        "type": "uint256"
      }
    ],
    "name": "getDataUnitRevenue",
    "outputs": [
         {
           "internalType": "uint256",
        "name": "",
           "type": "uint256"
         }
       ],
    "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [],
    "name": "getOwner",
       "outputs": [
         {
        "internalType": "address",
           "name": "",
        "type": "address"
         }
       ],
       "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [
         {
           "internalType": "address",
        "name": "_providerAddress",
           "type": "address"
      }
    ],
    "name": "getProviderDataUnits",
    "outputs": [
      {
        "components": [
         {
           "internalType": "uint256",
            "name": "id",
           "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "data",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
          },
         {
           "internalType": "string",
            "name": "dataUnitType",
           "type": "string"
     },
     {
            "internalType": "address payable",
            "name": "provider",
            "type": "address"
          },
         {
           "internalType": "uint256",
            "name": "totalRevenue",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "purchaseCount",
           "type": "uint256"
         }
       ],
        "internalType": "struct FXDataNetworkSepolia.DataUnit[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [
         {
           "internalType": "address",
        "name": "_providerAddress",
           "type": "address"
      }
    ],
    "name": "getProviderDetails",
    "outputs": [
      {
        "components": [
          {
            "internalType": "address payable",
            "name": "walletAddress",
           "type": "address"
         },
         {
            "internalType": "uint256",
            "name": "balance",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "bool",
            "name": "active",
            "type": "bool"
         },
         {
           "internalType": "uint256",
            "name": "sales",
           "type": "uint256"
         }
       ],
        "internalType": "struct FXDataNetworkSepolia.Provider",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
       "type": "function"
     },
     {
    "inputs": [
      {
        "internalType": "address",
        "name": "_providerAddress",
        "type": "address"
      }
    ],
    "name": "getProviderSales",
       "outputs": [
         {
        "internalType": "uint256",
           "name": "",
        "type": "uint256"
         }
       ],
       "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [],
    "name": "getContractBalance",
       "outputs": [
         {
           "internalType": "uint256",
           "name": "",
           "type": "uint256"
         }
       ],
       "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [],
    "name": "getDataUnitCreationCost",
       "outputs": [
         {
           "internalType": "uint256",
           "name": "",
           "type": "uint256"
         }
       ],
       "stateMutability": "view",
       "type": "function"
     },
     {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_dataUnitId",
        "type": "uint256"
      }
    ],
    "name": "getDataUnitRevenue",
       "outputs": [
         {
           "internalType": "uint256",
           "name": "",
           "type": "uint256"
         }
       ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getBuyerDataUnits",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "data",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "price",
            "type": "uint256"
          },
          {
            "internalType": "string",
            "name": "dataUnitType",
            "type": "string"
          },
          {
            "internalType": "address payable",
            "name": "provider",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "totalRevenue",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "purchaseCount",
            "type": "uint256"
          }
        ],
        "internalType": "struct FXDataNetworkSepolia.DataUnit[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "user",
        "type": "address"
      }
    ],
    "name": "getUserPurchaseCount",
       "outputs": [
         {
        "internalType": "uint256",
           "name": "",
        "type": "uint256"
         }
       ],
    "stateMutability": "view",
       "type": "function"
     },
     {
       "inputs": [
         {
           "internalType": "address",
        "name": "user",
           "type": "address"
         },
         {
           "internalType": "uint256",
        "name": "_dataUnitId",
           "type": "uint256"
         }
       ],
    "name": "hasUserPurchasedDataUnit",
       "outputs": [
         {
           "internalType": "bool",
           "name": "",
           "type": "bool"
         }
       ],
    "stateMutability": "view",
       "type": "function"
     },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "_name",
        "type": "string"
      }
    ],
    "name": "registerProvider",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "newCost",
        "type": "uint256"
      }
    ],
    "name": "setDataUnitCreationCost",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "withdrawBalance",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
];

export default contractABI;